// Array.prototype.at() used in pdfjs, appeared in browsers only 1-1.5 years ago, had a crash on older desktop Safari
// note: core-js (which is already installed) should be able to do this, but for some reason refuses to work
require('array.prototype.at').shim()